<template>
<div>
  <div class="word_1 previeweproject" ref="previewDom">
    <div class="a4">
         <h1 style="font-size:40px;margin-top:100px">
            贵州省建筑业协会专家库专家申请表
            <br />
          </h1>
         
          <p style="text-align: right; margin: 20px 0px 20px;  padding-right: 18px; float: right;">填报日期: {{ alldata?.created_at?.slice(0, 10)}}</p>
      <div style="display: flex;clear: both;">
        <div>
          <div class="th">
            <div class="td justify-center">姓 名</div>
            <div class="td justify-center">{{ alldata?.name }}</div>
            <div class="td justify-center">性 别</div>
            <div class="td justify-center">{{ alldata?.sex ==1?'男':'女' }}</div>
          </div>
          <div class="th">
            <div class="td justify-center">出生年月</div>
            <div class="td justify-center">{{ alldata?.birth }}</div>
            <div class="td justify-center">民 族</div>
            <div class="td justify-center" >{{ alldata?.nation }}</div>
          </div>
          <div class="th">
            <div class="td justify-center">所学专业</div>
            <div class="td justify-center" >{{ alldata?.major_studied }}</div>
            <div class="td justify-center">现从事专业</div>
            <div class="td justify-center" >{{ alldata?.major }}</div>
          </div>
          
        </div>
        <div class="td" style="width:140px;border: 1px solid black;">
          <p v-if="!alldata?.photo" style="text-align:center;line-height:169px">照片</p>
          <img width="140px" height="169px" v-if="alldata?.photo" :src="alldata.photo" alt="">
        </div>
      </div>
      <div class="th">
            <div class="td justify-center">身份证号</div>
            <div class="td justify-center" style="width:283px">{{ alldata?.idcard }}</div>
            <div class="td justify-center">从事专业工作年限</div>
            <div class="td justify-center">{{ alldata?.working_years }}</div>
          </div>
        <div class="th">
            <div class="td justify-center" style="font-size:14px">移动电话</div>
            <div class="td justify-center" style="width:283px">{{ alldata?.mobile }}</div>
            <div class="td justify-center">电子信箱</div>
            <div class="td justify-center">{{ alldata?.email }}</div>
          </div>
       <div class="th">
            <div class="td justify-center" style="font-size:14px">毕业院校及时间</div>
            <div class="td justify-center long">{{ alldata?.school }} {{alldata?.graduate_date}}</div>
          </div>
        <div class="th">
            <div class="td justify-center" style="font-size:14px">工作单位及职务</div>
            <div class="td justify-center long">{{ alldata?.unit }} {{ alldata?.job }}</div>
          </div>
        <div class="th">
            <div class="td justify-center" style="font-size:14px">技术职称及时间</div>
            <div class="td justify-center long">{{ alldata?.technical_title }} {{ alldata?.tech_date }}</div>
          </div>
         <div class="th">
            <div class="td justify-center" style="font-size:14px">获鲁班奖、国优奖项目及时间</div>
            <div class="td justify-center long">{{ alldata?.prize_projects }} {{ alldata?.prize_date }}</div>
          </div>
          
          <div class="th">
            <div class="td justify-center" style="font-size:14px">申报工作范围</div>
            <div class="td justify-center long">{{ alldata?.work_job_titles }}</div>
          </div>
      <div class="th dlth">
        <div class="td justify-center">工作经历</div>
        <div class="long justify-center" style="text-align:left;" >{{ alldata?.work_experience }}</div>
      </div>
      <div class="th dlth">
        <div class="td justify-center">主要业绩和论著</div>
        <div class="long justify-center" style="text-align:left;">{{ alldata?.performance }}</div>
      </div>
      
     </div>
      <div class="a4">
      <div class="th">
        <div class="td justify-center" style="height: 150px;">个人承诺</div>
        <div
          class="w_597 long"
          style="height: 150px;text-align: start;position: relative;padding-top: 50px;"
        >本人承诺以上信息真实、准确，并积极参与贵州省建筑业协会组织的相关工作。
          <div style="position: absolute;bottom: 10px;right: 0px;display:flex;width:100%;justify-content: space-between;">
            <p>本人签名：</p>
            <p>年 月 日</p>
          </div>
        </div>
      </div>
       <div class="th">
        <div class="td justify-center" style="height: 150px;">所在单位意见</div>
        <div
          class="w_597 long"
          style="height: 150px;text-align: start;position: relative;padding-top: 50px;"
        >本表所填信息真实、准确，经我单位审核，同意推荐该同志申报贵州省建筑业协会专家库专家。
          <div style="position: absolute;bottom:10px;right:20px">
            <p>单位（盖章）</p>
            <p>年 月 日</p>
          </div>
        </div>
      </div>
      <div class="th">
        <div class="td justify-center">申请表</div>
        <div
          class=" long"
          style="text-align:start;position: relative;"
        > 
            <p v-for="(row, index) in alldata.file_urls"
               :key="index">
                <a  target="_blank" :href="row.url">
                    {{ row.name }}
                </a>
            </p>
          
        </div>
      </div>
      <div class="th" style="height:170px">
        <div class="td justify-center" style="height:170px">身份证</div>
        <div
          class=" long"
          style="text-align:start;position: relative;height:170px"
        > 
           <img  height="149px" v-if="alldata?.idcard_front_pic" :src="alldata.idcard_front_pic" alt="">
           <img height="149px" style="margin-left:10px;" v-if="alldata?.idcard_reverse_pic" :src="alldata.idcard_reverse_pic" alt="">
        </div>
      </div>
      <div class="th">
        <div class="td justify-center">毕业证书及学位证书</div>
        <div
          class=" long"
          style="text-align:start;position: relative;"
        > 
            <p v-for="(row, index) in alldata.cert_graduate"
               :key="index">
                <a  target="_blank" :href="row.url">
                    {{ row.name }}
                </a>
            </p>
          
        </div>
      </div>
      <div class="th">
        <div class="td justify-center">职称资格证书</div>
        <div
          class=" long"
          style="text-align:start;position: relative;"
        > 
            <p v-for="(row, index) in alldata.cert_professional"
               :key="index">
                <a  target="_blank" :href="row.url">
                    {{ row.name }}
                </a>
            </p>
          
        </div>
      </div>
      <div class="th">
        <div class="td justify-center">单位聘用证书</div>
        <div
          class=" long"
          style="text-align:start;position: relative;"
        > 
            <p v-for="(row, index) in alldata.cert_employ"
               :key="index">
                <a  target="_blank" :href="row.url">
                    {{ row.name }}
                </a>
            </p>
          
        </div>
      </div>
      <div class="th">
        <div class="td justify-center">执业资格证书</div>
        <div
          class=" long"
          style="text-align:start;position: relative;"
        > 
            <p v-for="(row, index) in alldata.cert_practicing"
               :key="index">
                <a  target="_blank" :href="row.url">
                    {{ row.name }}
                </a>
            </p>
          
        </div>
      </div>
      <div class="th">
        <div class="td justify-center">业绩佐证材料</div>
        <div
          class=" long"
          style="text-align:start;position: relative;"
        > 
            <p v-for="(row, index) in alldata.cert_achievement"
               :key="index">
                <a  target="_blank" :href="row.url">
                    {{ row.name }}
                </a>
            </p>
          
        </div>
      </div>
    </div>
    </div>
    </div>
</template>

<script>
import self_adaption from './adaption'
export default {
  props: {
    alldata: {
      type: Object
    }
  },
  data() {
    return {
      xiahuaxian:"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
    };
  },
  created() {
  },
  mounted() {
    self_adaption()
    this.$emit('previewDom',this.$refs.previewDom)//整页DOM上传至父组件
  }
};
</script>

<style lang="less" scoped>
.word_1{
  width: 841px;
  margin: 0 auto;
}
.a4 {
  padding: 40px 60px;
  width: 842px;
  min-height: 1160px;
  margin: 0 auto;
  margin-top: 32px;
  background: #ffffff;
  box-sizing: border-box;
  color: black;
  p,
  h1 {
    font-family: "仿宋";
  }
  p {
    font-size: 26px;
    display: inline-block;
    width: 100%;
    text-align: start;
  }
  .th {
    display: flex;
    align-items: center;
    font-family: "仿宋";
    .td {
      width: 142px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid black;
      margin: 0 -1px -1px 0;
      text-align: center;
    }
    .long {
      width: 142px * 4px-3px;
      height: 40px;
      margin: 0 -1px -1px 0;
      border: 1px solid black;
      box-sizing: border-box;
    }
    .t_w180 {
      width: 213px-0.5px;
    }
  }
  .w_597 {
    width: 706px;
    height: 560px;
    padding: 5px 10px;
    border: 1px solid black;
    box-sizing: border-box;
    margin: 0 -1px -1px 0;
    word-break: break-all;
    font-size: 12px;
    word-wrap: break-word;
  }
  .w_60 {
    width: 80px;
    height: 240px;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    word-break: break-all;
    font-size: 12px;
  }
  .w_540 {
    width: 710px-80px-3px;
    height: 240px;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    box-sizing: border-box;
    word-break: break-all;
    word-wrap: break-word;
  }
  .justify-center{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.a3 {
  padding: 40px 0;
  width: 841px;
  height: 1189px;
  margin: 0 auto;
  margin-top: 32px;
  background: #ffffff;
  box-sizing: border-box;
  color: black;
  position: relative;
  .a3-box {
    height: 841px;
    width: 1189px;
    transform: rotate(90deg);
    position: absolute;
    left: -236px;
    top: 200px;
  }
  .th {
    display: flex;
    align-items: center;
    font-family: "仿宋";
  }
  .box {
    box-sizing: border-box;
    border: 1px solid black;
    margin: 0 -1px -1px 0;
    text-align: center;
    font-size: 14px;
    word-break: break-all;
  }
  .justify-center {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .blue {
    &:hover {
      color: rgb(81, 143, 201);
    }
  }
  .justify-start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: start;
  }
}

.a4 .th .long, .a4 .th .td {
    height: 60px;
}
.a4 .th .long  {
    overflow: hidden;
}
.a4 .w_60 , .a4 .w_597 {
    font-size: inherit;
}
.long p {
     font-size: inherit;
    display: inline-block;
    width: 100%;
    text-align: start;
    padding-left: 20px;
}

.a4 .th .long {
    word-wrap: break-word;
    word-break: break-all;
    height: auto;
    min-height: 60px;
}
.lth {
    min-height: 60px;
}
.lth .long {
    height: 180px!important;
}
.lth .td {
    height: 180px !important;
}
.dlth .long {
    height: 280px!important;
}
.dlth .td {
    height: 280px !important;
}
.dlth {
    min-height: 60px;
}

.a4 p{
    font-size: inherit !important;
}
</style>
